module.exports = __webpack_public_path__ + "static/media/ic-badge-verified.e2b65beb.png";